//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { formatDayLabel } from './scheduleResultGrouping.js';

const ALLOWED_GROUPS = ['session_format', 'session_topics', 'session_credit_type'];

export default {
  name: 'ScheduleFiltersTags',

  computed: {
    ...mapGetters(['filters', 'selectedDayValue']),
    dayChipLabel() {
      return this.selectedDayValue ? formatDayLabel(this.selectedDayValue) : '';
    },
    selectedFilters() {
      if (!this.filters) return [];
      return this.filters
        .filter(g => ALLOWED_GROUPS.includes(g.id))
        .flatMap(g => (g.filters || [])
          .filter(f => f.selected)
          .map(f => ({ ...f, groupId: g.id, groupName: g.name })));
    },
    groupedSelections() {
      const byGroup = {};
      this.selectedFilters.forEach(f => {
        if (!byGroup[f.groupId]) {
          byGroup[f.groupId] = { id: f.groupId, name: f.groupName, selected: [] };
        }
        byGroup[f.groupId].selected.push(f);
      });
      return ALLOWED_GROUPS.map(id => byGroup[id]).filter(Boolean);
    },
  },

  methods: {
    clearDay() {
      this.$store.commit('setSelectedDay', null);
      this.$store.dispatch('executeSearch');
    },
    removeFilter(filter) {
      this.$store.commit('setFilterValue', { filter, value: false });
      this.$store.dispatch('executeSearch');
    },
    clearAll() {
      this.selectedFilters.forEach(f => {
        this.$store.commit('setFilterValue', { filter: f, value: false });
      });
      this.$store.dispatch('executeSearch');
    },
  },
};
